<template>
  <div id="main">
    <div class="check">
      <img src="../../assets/common/default-3.png" />
      <span
        >&nbsp;{{ $t('当前') }}{{ isOrg ? $t('企业') : $t('个人')
        }}{{ $t('并无实名认证,请前往用户中心实名认证后再进行查看。') }}&nbsp;</span
      >
      <es-button variant="outline" @click="jump()">{{ $t('开始实名认证') }}</es-button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isOrg: state => state.isOrg,
    }),
  },
  components: {},
  data() {
    return {}
  },
  mounted() {},
  methods: {
    jump() {
      const data = {
        redirectUrl: this.$Dic.getDefaultURL().billUrl,
      }
      if (this.isOrg) {
        this.$ajax(this.$url.getOrgUrl(this.userInfo.orgId), data)
          .then(res => {
            window.location.href = res.data.url
          })
          .catch(res => {})
      } else {
        this.$ajax(this.$url.getPersonUrl(), data)
          .then(res => {
            window.location.href = res.data.url
          })
          .catch(res => {})
      }
    },
  },
}
</script>
<style lang="less" scoped>
.check {
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f0f2f5;
  > img {
    margin-bottom: 20px;
  }
  > span {
    padding: 40px 0 20px;
    font-size: 14px;
    font-weight: 400;
    color: #666;
    line-height: 20px;
  }
}
#main {
  position: absolute;
  width: 100%;
  top: 60px;
  bottom: 0;
  overflow-y: auto;
}
</style>
